import { useTranslation } from 'react-i18next'

interface HoneypotFieldProps {
  value: string
  onChange: (value: string) => void
}

/**
 * A decoy input real users never see (positioned off-screen by .hp-field,
 * kept out of the tab order and the accessibility tree). Bots that fill in
 * every field will fill this one, and the backend drops those submissions.
 */
function HoneypotField({ value, onChange }: HoneypotFieldProps) {
  const { t } = useTranslation()
  return (
    <div className="hp-field" aria-hidden="true">
      <label>
        {t('honeypot.label')}
        <input
          type="text"
          name="website"
          tabIndex={-1}
          autoComplete="off"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </label>
    </div>
  )
}

export default HoneypotField
